import apiService from "./apiService";
import AppConstants from "../appConstants";

class PeriodicityService {
    getAllPeriodicity(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_PERIODICITY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getPeriodicityDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_PERIODICITY}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerPeriodicity(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_PERIODICITY, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deletePeriodicity(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_PERIODICITY}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_PERIODICITY_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new PeriodicityService();
